<div class="row tax-estimates-inputs mb-5 dc-compact">
  <style>
    /* Detailed Calculation: compact, dense layout (keeps all rows/fields) */
    .dc-header-label {
      white-space: nowrap;
      display: block;
      line-height: 1.1;
      font-size: 15px;
      font-weight: 700;
      text-align: center;
    }
    .dc-compact { font-size: 16px; }

    /* Column header row: match other section headers (single-line, centered, compact) */
    .dc-compact .dc-sticky-header {
      position: sticky;
      top: 0;
      z-index: 5;
      height: 34px;
      color: #110646;
      background-color: #E5E5E5;
      border-radius: 0;
      display: flex;
      align-items: center;
      padding: 0 10px;
    }

    .dc-compact .dc-sticky-header .row { width: 100%; }
    .dc-compact .dc-sticky-header .column { padding-top: 0 !important; padding-bottom: 0 !important; }

    .dc-compact .user-title, .dc-compact label { font-size: 14px; margin: 0; }

    /* Reduce vertical whitespace */
    .dc-compact .row { margin-bottom: 0; }
    .dc-compact .mt-1 { margin-top: 0 !important; }
    .dc-compact .mt-2 { margin-top: 6px !important; }
    .dc-compact .mb-5 { margin-bottom: 16px !important; }

    /* Make inputs smaller */
    .dc-compact input[type="text"],
    .dc-compact .input-field {
      height: 30px;
      padding: 3px 8px;
      font-size: 13px;
      line-height: 1.2;
    }

    /* Notes: show as compact by default, expand on focus/hover so you can scan more rows */
    .dc-compact .input-field {
      width: 100%;
      max-width: 420px;
      transition: max-width 120ms ease-in-out;
    }
    .dc-compact .input-field:focus,
    .dc-compact .input-field:hover {
      max-width: 100%;
    }

    /* Tighten column spacing */
    .dc-compact .column { padding-top: 2px !important; padding-bottom: 2px !important; }

    /* Rebalance columns to match a 3/9 layout (25% / 75%) */
    .dc-compact .column.medium-3 { width: 25% !important; }
    .dc-compact .column.medium-9 { width: 75% !important; }

    .dc-compact .column.medium-6 { width: 60% !important; }
    .dc-compact .column.medium-2 { width: 13.333% !important; }

    /* Keep the diff column readable but compact */
    .dc-compact .dc-diff { white-space: nowrap; }

    /* Reduce icon/button footprint */
    .dc-compact .add-strategy i { font-size: 18px; }
    .dc-compact .badge.je-badge { line-height: 16px; height: 16px; padding: 0 4px; }

    /* Make section titles less tall */
    .dc-compact u { text-underline-offset: 2px; }
  </style>
    <div class="column medium-12 text-align-center bold" style="height: 36px;color: white;background-color: #475E79;padding: 5px 0;border-radius: 5px;">
      Detailed Calculation
    </div>
    <div class="column medium-12" style="padding: 0;">
      <div class="row mt-2 dc-sticky-header">
        <div class="column medium-3"></div>
        <div class="column medium-9">
          <div class="row bold">
            <div class="column medium-2">
              <span class="dc-header-label">Last Year {{currentPlanYear-1 || ''}}</span>
            </div>
            <div class="column medium-2">
              <span class="dc-header-label">Difference</span>
            </div>
            <div class="column medium-2">
              <span class="dc-header-label">Plan Year {{currentPlanYear || ''}}</span>
            </div>
            <div class="column medium-6">
              <span class="dc-header-label">Notes</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="padding: 10px 0;">
        <div class="column medium-12 bold">
          <u>Income</u>
          <span class="badge-tooltip">
            <span class="icon badge je-badge pointer" style="margin-left: 5px;" (click)="openStrategiesList()">ST</span>
            <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;font-weight: normal;">
              View strategy info
            </span>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1">
          <label class="user-title">Wages-Taxpayer</label>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.wagesTaxpayer.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('wagesTaxpayer', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.wagesTaxpayer.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.wagesTaxpayer.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('wagesTaxpayer', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.wagesTaxpayer.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('wagesTaxpayer')"style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'wagesTaxpayer')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'wagesTaxpayer')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('wagesTaxpayer')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3">
          <label class="user-title mt-1">Wages-Spouse</label>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.wagesSpouse.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('wagesSpouse', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.wagesSpouse.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.wagesSpouse.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('wagesSpouse', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.wagesSpouse.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('wagesSpouse')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'wagesSpouse')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'wagesSpouse')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('wagesSpouse')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Interest</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.interest.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('interest', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.interest.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.interest.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('interest', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.interest.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('interest')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'interest')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'interest')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('interest')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Dividends</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.dividents.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('dividents', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.dividents.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.dividents.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('dividents', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.dividents.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('dividents')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'dividents')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'dividents')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('dividents')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Business Income (Sch C)</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.businessIncome.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('businessIncome', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.businessIncome.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.businessIncome.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('businessIncome', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.businessIncome.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('businessIncome')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'businessIncome')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'businessIncome')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('businessIncome')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">ST Cap Gn</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.stCapGn.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('stCapGn', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.stCapGn.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.stCapGn.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('stCapGn', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.stCapGn.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('stCapGn')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'stCapGn')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'stCapGn')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('stCapGn')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">LT Cap Gn</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.ltCapGn.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('ltCapGn', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.ltCapGn.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.ltCapGn.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('ltCapGn', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.ltCapGn.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('ltCapGn')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'ltCapGn')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'ltCapGn')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('ltCapGn')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Other Gains or (Losses). Form 4797</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.otherGainsOrLosses.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('otherGainsOrLosses', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.otherGainsOrLosses.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.otherGainsOrLosses.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('otherGainsOrLosses', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.otherGainsOrLosses.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('otherGainsOrLosses')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'otherGainsOrLosses')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'otherGainsOrLosses')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('otherGainsOrLosses')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Rents & Royalties</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.rentsAndLoyalties.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('rentsAndLoyalties', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.rentsAndLoyalties.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.rentsAndLoyalties.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('rentsAndLoyalties', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.rentsAndLoyalties.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('rentsAndLoyalties')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'rentsAndLoyalties')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'rentsAndLoyalties')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('rentsAndLoyalties')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">K-1 Passthrough</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.k1Passthrough.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('k1Passthrough', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.k1Passthrough.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.k1Passthrough.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('k1Passthrough', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.k1Passthrough.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('k1Passthrough')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'k1Passthrough')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'k1Passthrough')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('k1Passthrough')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Other Income</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.otherIncome.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('otherIncome', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.otherIncome.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="incomeInfo.otherIncome.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateIncomeDifferenceAmount('otherIncome', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.otherIncome.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('otherIncome')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'otherIncome')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'otherIncome')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('otherIncome')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Total Income</div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{incomeInfo.totalIncome.lastYearValue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{incomeInfo.totalIncome.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{incomeInfo.totalIncome.currentYearvalue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="incomeInfo.totalIncome.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('totalIncome')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'totalIncome')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(incomeInfo, 'totalIncome')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('totalIncome')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="padding-bottom: 10px;">
        <div class="column medium-12 bold">
          <u>Adjustments to Income</u>
          <span class="badge-tooltip">
            <span class="icon badge je-badge pointer" style="margin-left: 5px;" (click)="openStrategiesList()">ST</span>
            <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;font-weight: normal;">
              View strategy info
            </span>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">HSA</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.hsa.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('hsa', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{adjustmentsToIncomeInfo.hsa.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.hsa.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('hsa', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="adjustmentsToIncomeInfo.hsa.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('hsa')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'hsa')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'hsa')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('hsa')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Retirement (IRA, SEP)-B/O by spouse</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.retirementBySpouse.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('retirementBySpouse', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{adjustmentsToIncomeInfo.retirementBySpouse.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.retirementBySpouse.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('retirementBySpouse', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="adjustmentsToIncomeInfo.retirementBySpouse.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('retirementBySpouse')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'retirementBySpouse')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'retirementBySpouse')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('retirementBySpouse')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Self Employed Tax (1/2)</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.selfEmployedTax.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('selfEmployedTax', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{adjustmentsToIncomeInfo.selfEmployedTax.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.selfEmployedTax.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('selfEmployedTax', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="adjustmentsToIncomeInfo.selfEmployedTax.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('selfEmployedTax')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'selfEmployedTax')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'selfEmployedTax')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('selfEmployedTax')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Self Employed Health Ins Ded</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.selfEmployedHealthInsDed.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('selfEmployedHealthInsDed', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{adjustmentsToIncomeInfo.selfEmployedHealthInsDed.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.selfEmployedHealthInsDed.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('selfEmployedHealthInsDed', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="adjustmentsToIncomeInfo.selfEmployedHealthInsDed.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('selfEmployedHealthInsDed')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'selfEmployedHealthInsDed')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'selfEmployedHealthInsDed')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('selfEmployedHealthInsDed')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Other Adjustments</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.otherAdjustments.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('otherAdjustments', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{adjustmentsToIncomeInfo.otherAdjustments.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="adjustmentsToIncomeInfo.otherAdjustments.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateAdjIncomeDifferenceAmount('otherAdjustments', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="adjustmentsToIncomeInfo.otherAdjustments.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('otherAdjustments')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'otherAdjustments')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'otherAdjustments')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('otherAdjustments')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Estimated Adjusted Gross Inc
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('estimatedAdjustedGrossInc')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('estimatedAdjustedGrossInc')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'estimatedAdjustedGrossInc')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(adjustmentsToIncomeInfo, 'estimatedAdjustedGrossInc')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('estimatedAdjustedGrossInc')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Sch A: Medical</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schAMedical.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schAMedical', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.schAMedical.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schAMedical.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schAMedical', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.schAMedical.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('schAMedical')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schAMedical')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schAMedical')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('schAMedical')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Sch A: Taxes</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schATaxes.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schATaxes', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.schATaxes.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schATaxes.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schATaxes', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.schATaxes.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('schATaxes')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schATaxes')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schATaxes')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('schATaxes')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Sch A: Interest</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schAInterest.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schAInterest', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.schAInterest.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schAInterest.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schAInterest', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.schAInterest.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('schAInterest')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schAInterest')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schAInterest')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('schAInterest')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Sch A: Charitable</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schACharitable.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schACharitable', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.schACharitable.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schACharitable.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schACharitable', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.schACharitable.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('schACharitable')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schACharitable')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schACharitable')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('schACharitable')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Sch A: Other or Limitation</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schAOtherOrLimitation.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schAOtherOrLimitation', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.schAOtherOrLimitation.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.schAOtherOrLimitation.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateItemizedDeductionsDiffAmount('schAOtherOrLimitation', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.schAOtherOrLimitation.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('schAOtherOrLimitation')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schAOtherOrLimitation')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'schAOtherOrLimitation')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('schAOtherOrLimitation')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Total Itemized Deductions</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.totalItemizedDeductions.lastYearValue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.totalItemizedDeductions.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.totalItemizedDeductions.currentYearvalue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.totalItemizedDeductions.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('totalItemizedDeductions')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'totalItemizedDeductions')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'totalItemizedDeductions')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('totalItemizedDeductions')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Standard Deduction
  <!--
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('standardDeduction')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
  -->
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.standardDeduction.lastYearValue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.standardDeduction.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.standardDeduction.currentYearvalue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.standardDeduction.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('standardDeduction')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'standardDeduction')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'standardDeduction')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('standardDeduction')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Taxable Inc (before QBI)
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('taxableIncBeforeQBI')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.taxableIncBeforeQBI.lastYearValue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.taxableIncBeforeQBI.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.taxableIncBeforeQBI.currentYearvalue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.taxableIncBeforeQBI.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('taxableIncBeforeQBI')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'taxableIncBeforeQBI')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'taxableIncBeforeQBI')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('taxableIncBeforeQBI')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Qualified Business Inc Ded</div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.qualifiedBusinessIncDed.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'"  (blur)="calculateItemizedDeductionsDiffAmount('qualifiedBusinessIncDed', 'previous')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.qualifiedBusinessIncDed.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.qualifiedBusinessIncDed.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'"  (blur)="calculateItemizedDeductionsDiffAmount('qualifiedBusinessIncDed', 'current')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.qualifiedBusinessIncDed.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('qualifiedBusinessIncDed')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'qualifiedBusinessIncDed')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'qualifiedBusinessIncDed')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('qualifiedBusinessIncDed')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-4 bold mt-1">Final Taxable Income
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('finalTaxableIncome')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.finalTaxableIncome.lastYearValue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.finalTaxableIncome.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.finalTaxableIncome.currentYearvalue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.finalTaxableIncome.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('finalTaxableIncome')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'finalTaxableIncome')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'finalTaxableIncome')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('finalTaxableIncome')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Tax (Ordinary)</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.taxOrdinary.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('taxOrdinary')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.taxOrdinary.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.taxOrdinary.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('taxOrdinary')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.taxOrdinary.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('taxOrdinary')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'taxOrdinary')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'taxOrdinary')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('taxOrdinary')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">AMT</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.amt.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('amt')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.amt.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.amt.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('amt')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.amt.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('amt')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'amt')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'amt')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('amt')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Other Taxes (NII, etc)</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.otherTaxes.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('otherTaxes')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.otherTaxes.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.otherTaxes.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('otherTaxes')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.otherTaxes.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('otherTaxes')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'otherTaxes')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'otherTaxes')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('otherTaxes')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">SE Tax</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.seTax.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('seTax')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.seTax.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.seTax.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('seTax')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.seTax.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('seTax')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'seTax')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'seTax')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('seTax')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
       <div class="row">
          <div class="column medium-3 mt-1"><label class="user-title">(Credits to Offset Tax Due)</label></div>
         <div class="column medium-9">
           <div class="row">
             <div class="column medium-2">
               <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.creditsToOffsetTaxDue.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('creditsToOffsetTaxDue')"/>
             </div>
             <div class="column medium-2 mt-1">
               <span class="dc-diff">{{otherDetailedInfo.creditsToOffsetTaxDue.difference | formatAmount:'$0,0'}}</span>
             </div>
             <div class="column medium-2">
               <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.creditsToOffsetTaxDue.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('creditsToOffsetTaxDue')"/>
             </div>
             <div class="column medium-6">
               <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.creditsToOffsetTaxDue.notes" placeholder="Notes"/>
               <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('creditsToOffsetTaxDue')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'creditsToOffsetTaxDue')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
               </span>
               <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'creditsToOffsetTaxDue')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('creditsToOffsetTaxDue')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
             </div>
           </div>
         </div>
       </div>
       <div class="row">
        <div class="column medium-3 bold mt-1">Total Tax
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('totalTax')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
        </div>
         <div class="column medium-9">
           <div class="row">
             <div class="column medium-2 mt-1">
               <span>{{otherDetailedInfo.totalTax.lastYearValue | formatAmount:'$0,0'}}</span>
             </div>
             <div class="column medium-2 mt-1">
               <span class="dc-diff">{{otherDetailedInfo.totalTax.difference | formatAmount:'$0,0'}}</span>
             </div>
             <div class="column medium-2 mt-1">
               <span>{{otherDetailedInfo.totalTax.currentYearvalue | formatAmount:'$0,0'}}</span>
             </div>
             <div class="column medium-6">
               <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.totalTax.notes" placeholder="Notes"/>
               <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('totalTax')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'totalTax')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
               </span>
               <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'totalTax')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('totalTax')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
             </div>
           </div>
         </div>
       </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Withholding (FIT)-Taxpayer</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.withholdingTaxpayer.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('withholdingTaxpayer')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.withholdingTaxpayer.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.withholdingTaxpayer.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('withholdingTaxpayer')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.withholdingTaxpayer.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('withholdingTaxpayer')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'withholdingTaxpayer')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'withholdingTaxpayer')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('withholdingTaxpayer')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Withholding (FIT)-Spouse</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.withholdingSpouse.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('withholdingSpouse')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.withholdingSpouse.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.withholdingSpouse.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('withholdingSpouse')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.withholdingSpouse.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('withholdingSpouse')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'withholdingSpouse')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'withholdingSpouse')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('withholdingSpouse')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Estimated Tax Payments</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.estimatedTaxPayments.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('estimatedTaxPayments')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span class="dc-diff">{{otherDetailedInfo.estimatedTaxPayments.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.estimatedTaxPayments.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateDifference('estimatedTaxPayments')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.estimatedTaxPayments.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('estimatedTaxPayments')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'estimatedTaxPayments')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'estimatedTaxPayments')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('estimatedTaxPayments')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Net Tax Due
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('netTaxDue')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.netTaxDue.lastYearValue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.netTaxDue.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.netTaxDue.currentYearvalue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.netTaxDue.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('netTaxDue')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'netTaxDue')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'netTaxDue')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('netTaxDue')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 mt-1"><label class="user-title">Underpayment Penalty</label></div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.underPaymentPenalties.lastYearValue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calcualtePenaltiesDiff('underPaymentPenalties')"/>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.underPaymentPenalties.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2">
              <input type="text"  placeholder="" [(ngModel)]="otherDetailedInfo.underPaymentPenalties.currentYearvalue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calcualtePenaltiesDiff('underPaymentPenalties')"/>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.underPaymentPenalties.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('underPaymentPenalties')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'underPaymentPenalties')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'underPaymentPenalties')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('underPaymentPenalties')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Total Due w/Penalties/Int
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('totalDue')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.totalDue.lastYearValue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.totalDue.difference | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.totalDue.currentYearvalue | formatAmount:'$0,0'}}</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.totalDue.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('totalDue')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'totalDue')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'totalDue')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('totalDue')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Effective Tax Rate
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('effectiveTaxRate')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.effectiveTaxRate.lastYearValue | formatAmount:'0,0.00'}}%</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.effectiveTaxRate.difference | formatAmount:'0,0.00'}}%</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.effectiveTaxRate.currentYearvalue | formatAmount:'0,0.00'}}%</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.effectiveTaxRate.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('effectiveTaxRate')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'effectiveTaxRate')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'effectiveTaxRate')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('effectiveTaxRate')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column medium-3 bold mt-1">Marginal Tax Rate
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline" (click)="showFormulaInfo('marginalTaxRate')"></i>
            <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
              Click here to link to see formula
            </span>
          </span>
        </div>
        <div class="column medium-9">
          <div class="row">
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.marginalTaxRate.lastYearValue || 0}}%</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.marginalTaxRate.difference || 0}}%</span>
            </div>
            <div class="column medium-2 mt-1">
              <span>{{otherDetailedInfo.marginalTaxRate.currentYearvalue || 0}}%</span>
            </div>
            <div class="column medium-6">
              <input class="float-left input-field" type="text" [(ngModel)]="otherDetailedInfo.marginalTaxRate.notes" placeholder="Notes"/>
              <span class="pointer badge-tooltip add-strategy" *ngIf="suggestionsData && !suggestionsData.hasOwnProperty('marginalTaxRate')" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'marginalTaxRate')">
                <i class="material-icons">add_circle_outline</i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a strategy to notes
                </span>
              </span>
              <span class="pointer badge-tooltip add-strategy" style="margin: 8px 0 0 5px" (click)="addSuggestedStrategyToEstimate(otherDetailedInfo, 'marginalTaxRate')" *ngIf="suggestionsData && suggestionsData.hasOwnProperty('marginalTaxRate')">
                <i class="icon ion-android-bulb"></i>
                <span class="bottomTooltiptext" style="width: 150px;margin-left: -75px;">
                  Add a suggested strategy to notes
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div style="display: none;">
    <div id="estimate-detail-report">
      <table style="font-size: 15px; margin-top: 30px; width: 100%;">
        <thead style="background: none;">
        <tr style="height: 36px;font-weight:bold;color: white;background-color: #475E79;padding: 5px 0;border-radius: 5px;">
          <th style="text-align: center;">
            Detailed Calculation
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <table style="width: 100%;">
              <thead>
              <tr style="height: 36px;color: #110646;background-color: #E5E5E5;padding: 5px 0;margin-top: 5px;border-radius: 5px;">
                <th></th>
                <th style="text-align: center;">Last Year <br/> {{currentPlanYear-1 || ''}}</th>
                <th style="text-align: center;">Difference</th>
                <th style="text-align: center;">Plan Year <br/> {{currentPlanYear || ''}}</th>
                <th style="text-align: center;">Notes</th>
              </tr>
              </thead>
              <tbody>
              <tr style="height: 36px;">
                <td style="font-weight: bold"><u>Income</u></td>
                <td style="text-align: center;"></td>
                <td style="text-align: center;"></td>
                <td style="text-align: center;"></td>
                <td style="text-align: center;"></td>
              </tr>
              <tr style="height: 36px;">
                <td>Wages-Taxpayer</td>
                <td style="text-align: center;">{{incomeInfo.wagesTaxpayer.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.wagesTaxpayer.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.wagesTaxpayer.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.wagesTaxpayer.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Wages-Spouse</td>
                <td style="text-align: center;">{{incomeInfo.wagesSpouse.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.wagesSpouse.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.wagesSpouse.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.wagesSpouse.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Interest</td>
                <td style="text-align: center;">{{incomeInfo.interest.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.interest.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.interest.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.interest.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Dividends</td>
                <td style="text-align: center;">{{incomeInfo.dividents.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.dividents.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.dividents.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.dividents.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Business Income (Sch C)</td>
                <td style="text-align: center;">{{incomeInfo.businessIncome.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.businessIncome.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.businessIncome.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.businessIncome.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>ST Cap Gn</td>
                <td style="text-align: center;">{{incomeInfo.stCapGn.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.stCapGn.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.stCapGn.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.stCapGn.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>LT Cap Gn</td>
                <td style="text-align: center;">{{incomeInfo.ltCapGn.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.ltCapGn.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.ltCapGn.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.ltCapGn.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Other Gains or (Losses). Form 4797</td>
                <td style="text-align: center;">{{incomeInfo.otherGainsOrLosses.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.otherGainsOrLosses.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.otherGainsOrLosses.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.otherGainsOrLosses.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Rents & Royalties</td>
                <td style="text-align: center;">{{incomeInfo.rentsAndLoyalties.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.rentsAndLoyalties.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.rentsAndLoyalties.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.rentsAndLoyalties.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>K-1 Passthrough</td>
                <td style="text-align: center;">{{incomeInfo.k1Passthrough.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.k1Passthrough.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.k1Passthrough.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.k1Passthrough.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Other Income</td>
                <td style="text-align: center;">{{incomeInfo.otherIncome.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.otherIncome.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.otherIncome.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.otherIncome.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Total Income</td>
                <td style="text-align: center;">{{incomeInfo.totalIncome.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.totalIncome.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{incomeInfo.totalIncome.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{incomeInfo.totalIncome.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold"><u>Adjustments to Income</u></td>
                <td style="text-align: center;"></td>
                <td style="text-align: center;"></td>
                <td style="text-align: center;"></td>
                <td style="text-align: center;"></td>
              </tr>
              <tr style="height: 36px;">
                <td>HSA</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.hsa.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.hsa.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.hsa.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{adjustmentsToIncomeInfo.hsa.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Retirement (IRA, SEP)-B/O by spouse</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.retirementBySpouse.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.retirementBySpouse.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.retirementBySpouse.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{adjustmentsToIncomeInfo.retirementBySpouse.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Self Employed Tax (1/2)</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.selfEmployedTax.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.selfEmployedTax.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.selfEmployedTax.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{adjustmentsToIncomeInfo.selfEmployedTax.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Self Employed Health Ins Ded</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.selfEmployedHealthInsDed.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.selfEmployedHealthInsDed.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.selfEmployedHealthInsDed.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{adjustmentsToIncomeInfo.selfEmployedHealthInsDed.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Other Adjustments</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.otherAdjustments.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.otherAdjustments.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.otherAdjustments.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{adjustmentsToIncomeInfo.otherAdjustments.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Estimated Adjusted Gross Inc</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.notes}}</td>
              </tr>
  
              <tr style="height: 36px;">
                <td>Sch A: Medical</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAMedical.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAMedical.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAMedical.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.schAMedical.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Sch A: Taxes</td>
                <td style="text-align: center;">{{otherDetailedInfo.schATaxes.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schATaxes.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schATaxes.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.schATaxes.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Sch A: Interest</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAInterest.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAInterest.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAInterest.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.schAInterest.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Sch A: Charitable</td>
                <td style="text-align: center;">{{otherDetailedInfo.schACharitable.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schACharitable.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schACharitable.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.schACharitable.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Sch A: Other or Limitation</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAOtherOrLimitation.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAOtherOrLimitation.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.schAOtherOrLimitation.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.schAOtherOrLimitation.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Total Itemized Deductions</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalItemizedDeductions.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalItemizedDeductions.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalItemizedDeductions.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.totalItemizedDeductions.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Standard Deduction</td>
                <td style="text-align: center;">{{otherDetailedInfo.standardDeduction.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.standardDeduction.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.standardDeduction.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.standardDeduction.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Taxable Inc (before QBI)</td>
                <td style="text-align: center;">{{otherDetailedInfo.taxableIncBeforeQBI.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.taxableIncBeforeQBI.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.taxableIncBeforeQBI.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.taxableIncBeforeQBI.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Qualified Business Inc Ded</td>
                <td style="text-align: center;">{{otherDetailedInfo.qualifiedBusinessIncDed.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.qualifiedBusinessIncDed.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.qualifiedBusinessIncDed.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.qualifiedBusinessIncDed.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Final Taxable Income</td>
                <td style="text-align: center;">{{otherDetailedInfo.finalTaxableIncome.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.finalTaxableIncome.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.finalTaxableIncome.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.finalTaxableIncome.notes}}</td>
              </tr>
  
              <tr style="height: 36px;">
                <td>Tax (Ordinary)</td>
                <td style="text-align: center;">{{otherDetailedInfo.taxOrdinary.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.taxOrdinary.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.taxOrdinary.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.taxOrdinary.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>AMT</td>
                <td style="text-align: center;">{{otherDetailedInfo.amt.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.amt.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.amt.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.amt.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Other Taxes (NII, etc)</td>
                <td style="text-align: center;">{{otherDetailedInfo.otherTaxes.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.otherTaxes.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.otherTaxes.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.otherTaxes.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>SE Tax</td>
                <td style="text-align: center;">{{otherDetailedInfo.seTax.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.seTax.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.seTax.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.seTax.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>(Credits to Offset Tax Due)</td>
                <td style="text-align: center;">{{otherDetailedInfo.creditsToOffsetTaxDue.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.creditsToOffsetTaxDue.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.creditsToOffsetTaxDue.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.creditsToOffsetTaxDue.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Total Tax</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalTax.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalTax.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalTax.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.totalTax.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Withholding (FIT)-Taxpayer</td>
                <td style="text-align: center;">{{otherDetailedInfo.withholdingTaxpayer.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.withholdingTaxpayer.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.withholdingTaxpayer.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.withholdingTaxpayer.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Withholding (FIT)-Spouse</td>
                <td style="text-align: center;">{{otherDetailedInfo.withholdingSpouse.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.withholdingSpouse.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.withholdingSpouse.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.withholdingSpouse.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Estimated Tax Payments</td>
                <td style="text-align: center;">{{otherDetailedInfo.estimatedTaxPayments.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.estimatedTaxPayments.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.estimatedTaxPayments.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.estimatedTaxPayments.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Net Tax Due</td>
                <td style="text-align: center;">{{otherDetailedInfo.netTaxDue.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.netTaxDue.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.netTaxDue.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.netTaxDue.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Underpayment Penalty</td>
                <td style="text-align: center;">{{otherDetailedInfo.underPaymentPenalties.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.underPaymentPenalties.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.underPaymentPenalties.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.underPaymentPenalties.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Total Due w/Penalties/Int</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalDue.lastYearValue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalDue.difference | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{otherDetailedInfo.totalDue.currentYearvalue | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.totalDue.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Effective Tax Rate</td>
                <td style="text-align: center;">{{otherDetailedInfo.effectiveTaxRate.lastYearValue | formatAmount:'0,0.00'}}%</td>
                <td style="text-align: center;">{{otherDetailedInfo.effectiveTaxRate.difference | formatAmount:'0,0.00'}}%</td>
                <td style="text-align: center;">{{otherDetailedInfo.effectiveTaxRate.currentYearvalue | formatAmount:'0,0.00'}}%</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.effectiveTaxRate.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td style="font-weight: bold;">Marginal Tax Rate</td>
                <td style="text-align: center;">{{otherDetailedInfo.marginalTaxRate.lastYearValue || 0}}%</td>
                <td style="text-align: center;">{{otherDetailedInfo.marginalTaxRate.difference || 0}}%</td>
                <td style="text-align: center;">{{otherDetailedInfo.marginalTaxRate.currentYearvalue || 0}}%</td>
                <td style="text-align: center;width: 130px;">{{otherDetailedInfo.marginalTaxRate.notes}}</td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  <div *ngIf="reveal['displayFormulaInfo']">
    <div class="reveal-overlay" [ngClass]="{'qount-reveal': reveal['displayFormulaInfo']}">
    </div>
    <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'qount-reveal': reveal['displayFormulaInfo']}">
      <div class="header" style="height: 50px; background-color: #16477a; padding: 15px; color: #fff;">
        <span class="float-left">Formula Info</span>
        <span class="float-right pointer" (click)="hideReveal('displayFormulaInfo')">X</span>
      </div>
      <div class="body reveal-publish" style="padding: 15px;">
        <div class="row row-padding-reveal">
          <div class="small-12 medium-12">
            <p *ngIf="currentInfoKey == 'estimatedAdjustedGrossInc'">Estimated Adjusted Gross Inc = Total Income - (HSA + Retirement (IRA, SEP)-B/O by spouse + Self Employed Tax (1/2) + Self Employed Health Ins Ded + Other Adjustments).</p>
            <ng-template [ngIf]="currentInfoKey == 'taxableIncBeforeQBI'">
              <p>If "Total Itemized Deductions" is greater than or equal to "Standard Deduction", then the calculation will equal "Estimated Adjusted Gross Inc" - "Total Itemized Deductions".</p>
              <p>If "Total Itemized Deductions" is less than "Standard Deduction", then the calculation will equal "Estimated Adjusted Gross Inc" - "Standard Deduction".</p>
            </ng-template>
            <p *ngIf="currentInfoKey == 'finalTaxableIncome'">Final Taxable Income = Taxable Inc (before QBI) - Qualified Business Inc Ded.</p>
            <p *ngIf="currentInfoKey == 'netTaxDue'">Net Tax Due = Total Tax - (Withholding (FIT) Taxpayer + Withholding (FIT) Spouse + Estimated Tax Payments)</p>
            <p *ngIf="currentInfoKey == 'totalDue'">Total Due w/Penalties/Int = Net Tax Due + Underpayment Penalty</p>
            <p *ngIf="currentInfoKey == 'effectiveTaxRate'">Effective Tax Rate = (Total Tax / Final Taxable Income) * 100</p>
            <p *ngIf="currentInfoKey == 'totalTax'">Total Tax = Tax (Ordinary) + AMT + Other Taxes (NII, etc) + SE Tax + Credits to Offset Tax Due</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="reveal['showStrategies']">
    <div class="reveal-overlay" [ngClass]="{'qount-reveal': reveal['showStrategies']}">
    </div>
    <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'qount-reveal': reveal['showStrategies']}">
      <div class="header" style="height: 50px; background-color: #16477a; padding: 15px; color: #fff;">
        <span class="float-left">Strategies</span>
        <span class="float-right pointer" (click)="hideReveal('showStrategies')">X</span>
      </div>
      <div class="body reveal-publish" style="padding: 15px;">
        <div class="row row-padding-reveal mb-3">
          <div class="medium-3 columns">
            <div style="margin-top: 5px;">Strategy</div>
          </div>
          <div class="medium-6 columns">
            <label>
              <qount-select-dropdown [setData]="strategiesList" [includeNone]="false" (onValueSelect)="openStrategyInfo($event)"
                                     [setDefaultValue]="" [setSearchKey]="'name'" [setPlaceHolder]="'Select Strategy'" [setValueKey]="'id'">
              </qount-select-dropdown>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="medium-12 columns row-padding-reveal">
            <button class="button small float-right" (click)="viewStrategy()">View</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="reveal['addStrategyToestimate']">
    <div class="reveal-overlay" [ngClass]="{'qount-reveal': reveal['addStrategyToestimate']}">
    </div>
    <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'qount-reveal': reveal['addStrategyToestimate']}">
      <div class="header" style="height: 50px; background-color: #16477a; padding: 15px; color: #fff;">
        <span class="float-left">Add Strategies to Notes</span>
        <span class="float-right pointer" (click)="hideReveal('addStrategyToestimate')">X</span>
      </div>
      <div class="body reveal-publish" style="padding: 15px;">
        <div class="row row-padding-reveal mb-3">
          <div class="medium-3 columns">
            <div style="margin-top: 5px;">Strategies</div>
          </div>
          <div class="medium-6 columns filter-option-wrapper-max">
            <ng-multiselect-dropdown
              name="strategy"
              [placeholder]="'Select Strategies'"
              [settings]="strategyDropdownSettings"
              [data]="strategiesList"
              [(ngModel)]="selectedStrategies"
              (onSelect)="onStrategyFilterSelect($event, true)"
              (onDeSelect)="onStrategyFilterSelect($event, false)"
              (onSelectAll)="onAllStrategiesFilterSelect($event, true)"
              (onDeSelectAll)="onAllStrategiesFilterSelect($event, false)">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="row">
          <div class="medium-12 columns row-padding-reveal">
            <button class="button small float-right" (click)="addSelectedStrategies()">Add</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="reveal['addSuggestionToEstimate']">
    <div class="reveal-overlay" (click)="minimizeReveal('addSuggestionToEstimate')" [ngClass]="{'qount-reveal': reveal['addSuggestionToEstimate']}">
    </div>
    <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'qount-reveal': reveal['addSuggestionToEstimate']}">
      <div class="header" style="height: 50px; background-color: #16477a; padding: 15px; color: #fff;">
        <span class="float-left">Add Strategies to Notes</span>
        <span class="float-right pointer" (click)="hideReveal('addSuggestionToEstimate')">X</span>
        <span class="float-right">
          <i class="material-icons" style="color: #fff; font-size: 1.7em;margin-right: 6px" (click)="minimizeReveal('addSuggestionToEstimate')">keyboard_arrow_down</i>
        </span>
      </div>
      <div class="body reveal-publish" style="padding: 15px;max-height: 75vh;overflow-y: scroll;">
        <ng-template [ngIf]="isSuggestionExist">
          <div class="row row-padding-reveal">
            <div class="medium-12 columns">Suggested Strategies:</div>
          </div>
          <div class="row row-padding-reveal mb-4">
            <div class="medium-12 columns">
              <mat-chip-list>
                <mat-chip *ngFor="let suggestion of suggestionsList">
                  <input class="pointer" style="margin: 0 2px 0 0" type="checkbox" [(ngModel)]="suggestion.selected" [checked]="suggestion.selected" (change)="openAddStrategyPopup(suggestion)"/>
                  <a (click)="viewStrategyInfo(suggestion)" style="text-decoration: underline;">{{suggestion.strategyName}}</a>
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
          <div class="row row-padding-reveal">
            <div class="medium-12 columns">Also, you could go through the list of other strategies and add them to this tax item.</div>
          </div>
        </ng-template>
        <div class="row row-padding-reveal">
          <div class="medium-4 columns">
            <div style="margin-top: 5px;">{{isSuggestionExist ? 'Other Strategies' : 'Strategies'}}</div>
          </div>
          <div class="medium-6 columns filter-option-wrapper-max">
            <ng-multiselect-dropdown
              name="strategy"
              [placeholder]="'Select Strategies'"
              [settings]="strategyDropdownSettings"
              [data]="strategiesList"
              [(ngModel)]="selectedStrategies"
              (onSelect)="onStrategyFilterSelect($event, true)"
              (onDeSelect)="onStrategyFilterSelect($event, false)">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="row row-padding-reveal mb-3">
          <div class="medium-12 columns">
            <mat-chip-list>
              <mat-chip *ngFor="let strategy of selectedStrategies">
                <a (click)="viewStrategyInfo(strategy,'other')">{{strategy.name}}</a>
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>
        <div class="row">
          <div class="medium-12 columns row-padding-reveal">
            <button class="button small float-right" (click)="addSelectedStrategies('suggestion')">Add</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="reveal['addStrategyFromEstimate']">
    <div class="reveal-overlay" [ngClass]="{'qount-reveal': reveal['addStrategyFromEstimate']}">
    </div>
    <div class="reveal tax-strategy-reveal" [ngClass]="{'qount-reveal': reveal['addStrategyFromEstimate']}">
      <div class="header strategy-header">
        <span class="float-left">Add Strategy</span>
        <span class="float-right pointer" (click)="hideReveal('addStrategyFromEstimate')">X</span>
      </div>
      <div class="body reveal-publish" style="padding: 15px;height: 75vh;overflow-y: scroll;">
        <tp-add-strategy [selectedStrategy]="currentSelectedSuggestion" [clientsList]="clientsList" [planYear]="currentPlanYear" [strategiesList]="strategiesList" [associatedWithData]="associatedWithData"
        [stateAssociatedWithData]="stateAssociatedWithData" [taxPlanData]="taxPlanData" [allAssociatedData]="allAssociatedData"
        [clientData]="clientData" (onAddStrategyAction)="triggerOnAddStrategy($event)" [isSuggestion]="isSuggestionExist"></tp-add-strategy>
      </div>
    </div>
  </div>
  
  <div class="row min-wall-add-task minimized-add-strategy add-strategy-suggestion" style="width: 300px;" *ngIf="isMinimized">
    <div class="small-6 medium-8 columns min-title">{{isSuggestionExist ? 'Add Suggestions!' : 'Add Strategy!'}}</div>
    <div class="small-6 medium-4 columns" style="text-align: right">
      <span><i class="material-icons min-task" (click)="addSuggestedStrategyToEstimate(currentObject, currentKey)">keyboard_arrow_up</i></span>
      <span><i class="material-icons min-close" (click)="hideReveal('addSuggestionToEstimate')">clear</i></span>
    </div>
  </div>
  